export const spacingTheme = {
    spacing2: '0.125rem',
    spacing4: '0.25rem',
    spacing8: '0.5rem',
    spacing16: '1rem',
    spacing24: '1.5rem',
    spacing32: '2rem',
    spacing48: '3rem',
    spacing64: '4rem',
};
//# sourceMappingURL=theme.js.map